import { validate_email } from '@/utils/validations/validate_inputs';

export function show_modal(modal_id) {
  const modal_element = document.getElementById(modal_id);
  const bootstrap_modal = window?.bootstrap?.Modal;

  if (!modal_element || !bootstrap_modal) {
    return;
  }

  new bootstrap_modal(modal_element).show();
}

export function hide_modal(modal_id) {
  const modal_element = document.getElementById(modal_id);
  const modal = window?.bootstrap?.Modal?.getInstance(modal_element);

  if (modal) {
    modal.hide();
  }
}

export function build_child_tabs(rows) {
  const child_tabs = (rows || [])
    .map((row) => {
      const child_tab = {
        id: `child-${Number(row.child_entity_type_id || 0)}`,
        label: String(row.child_entity_type_name || "Entity Type"),
        has_dropdown: true,
        _child_entity_type_id: Number(row.child_entity_type_id || 0),
        _is_child_type_tab: true,
      };

      return child_tab;
    })
    .filter((tab) => tab._child_entity_type_id);

  return child_tabs;
}

export function get_insert_index(vm) {
  const application_data_index = (vm.visible_tabs || []).findIndex((tab) => {
    const key = vm.normalize_tab_key(tab?.id || tab?.label);
    return key === "application_data";
  });
  let insert_index = 1;

  if (application_data_index !== -1) {
    insert_index = application_data_index + 1;
  } else {
    const application_forms_index = (vm.visible_tabs || []).findIndex((tab) => {
      const key = vm.normalize_tab_key(tab?.id || tab?.label);
      return key === "application_forms";
    });

    if (application_forms_index !== -1) {
      insert_index = application_forms_index + 1;
    }
  }

  return insert_index;
}

export function build_assign_options(rows) {
  const assign_options = (rows || []).map((row) => {
    const assign_option = {
      id: Number(row.child_entity_type_id),
      name: row.child_entity_type_name || "Unnamed",
    };

    return assign_option;
  });

  return assign_options;
}

export function get_validation_error(vm) {
  const validation_checks = [
    {
      is_invalid: !vm.current_form?.parent_application_id,
      message: "Missing parent application.",
    },
    {
      is_invalid: !Number(vm.assign_sub_entity_type_id || 0),
      message: "Please select a sub-entity type.",
    },
    {
      is_invalid: !Number(vm.assign_selected_form_id || 0),
      message: "Please select a form for the sub-entity.",
    },
    {
      is_invalid: !(vm.assign_entity_name || "").trim(),
      message: "Please enter the sub-entity name.",
    },
    {
      is_invalid:
        vm.include_email && !validate_email((vm.assign_email || "").trim()),
      message: "Please enter a valid email address.",
    },
  ];
  const failed_check = validation_checks.find(
    (validation_check) => validation_check.is_invalid
  );
  const validation_error = failed_check?.message || null;

  return validation_error;
}

export function build_sub_entity_payload(vm) {
  const payload = {
    parent_application_id: Number(vm.current_form.parent_application_id),
    entity_type_id: Number(vm.assign_sub_entity_type_id),
    parent_entity_type_id: Number(vm.current_form.parent_id),
    parent_entity_profile_id: Number(vm.current_form.parent_entity_profile_id),
    form_ids: [Number(vm.assign_selected_form_id)],
    entity_name: (vm.assign_entity_name || "").trim(),
  };

  if (vm.project_id) {
    payload.project_id = Number(vm.project_id);
  }

  if (vm.include_email) {
    payload.email = (vm.assign_email || "").trim();
  }

  return payload;
}

export function normalize_response_data(response, include_email) {
  const response_data = include_email ? JSON.parse(response.data) : response.data;

  return response_data;
}

export function get_first_present_value(values, fallback = "") {
  const selected_value = values.find(
    (value) => value !== undefined && value !== null && value !== ""
  );
  const first_present_value = selected_value ?? fallback;

  return first_present_value;
}

export function as_record(value) {
  let record = {};

  if (value !== null && typeof value === "object") {
    record = value;
  }

  return record;
}

export function get_child_raw(item) {
  const child_raw = Reflect.get(as_record(item), "_child_raw") || {};

  return child_raw;
}

export function get_child_forms(item) {
  const child_raw = get_child_raw(item);
  const forms = Reflect.get(child_raw, "forms");
  const child_forms = Array.isArray(forms) ? forms : [];

  return child_forms;
}

export function get_child_profile_roles(item) {
  const child_raw = get_child_raw(item);
  const profile_roles = Reflect.get(child_raw, "profile_role");
  const child_profile_roles = Array.isArray(profile_roles) ? profile_roles : [];

  return child_profile_roles;
}

export function get_child_profile_user_id(item) {
  const first_profile_role = get_child_profile_roles(item)[0] || {};
  const user_id = Reflect.get(first_profile_role, "user_id");
  const normalized_user_id = Number(user_id || 0);

  return normalized_user_id;
}

export function get_status_value(row) {
  const safe_row = as_record(row);
  const raw_status = Reflect.get(safe_row, "status");
  const nested_status =
    raw_status !== null && typeof raw_status === "object"
      ? Reflect.get(raw_status, "status")
      : null;
  const status_value = get_first_present_value(
    [Reflect.get(safe_row, "Status"), nested_status, raw_status],
    ""
  );

  return status_value;
}

export function get_entity_type_name(item, fallback = "Entity") {
  const child_raw = get_child_raw(item);
  const entity_type_name = get_first_present_value(
    [
      Reflect.get(item || {}, "Entity Type"),
      item?.entity_type_name,
      Reflect.get(child_raw, "entity_type_name"),
    ],
    fallback
  );

  return entity_type_name;
}

export function get_entity_profile_id(item, is_child) {
  let entity_profile_id = Number(
    get_first_present_value([item?.entity_profile_id, item?.id], 0)
  );

  if (is_child) {
    entity_profile_id = Number(
      get_first_present_value([item?.id, item?.entity_profile_id], 0)
    );
  }

  return entity_profile_id;
}

export function build_current_parent_context(vm) {
  const parent_context = {
    parent_application_id: String(vm.application_id || ""),
    parent_entity_profile_id: String(vm.entity_profile_id || ""),
    parent_user_id: String(vm.viewed_user_id || ""),
    parent_entity_type_id: String(vm.entity_type_id || ""),
    parent_entity_name: get_first_present_value([vm.entity_name], ""),
    parent_entity_type_name: get_first_present_value(
      [vm.current_entity?.entity_type_name, vm.$route?.query?.entity_type_name],
      ""
    ),
    parent_status: get_first_present_value(
      [vm.application_status, vm.$route?.query?.status],
      ""
    ),
    parent_active_tab: get_first_present_value([vm.active_tab], ""),
    parent_master_tab: get_first_present_value([vm.active_master_tab], "profile"),
  };

  return parent_context;
}

export function build_child_navigation_query(vm, row) {
  const safe_row = as_record(row);
  const child_raw = get_child_raw(row);
  const child_forms = get_child_forms(row);
  const application_id = Number(
    get_first_present_value(
      [Reflect.get(safe_row, "Application No"), safe_row.application_id, safe_row.id],
      0
    )
  );
  const entity_profile_id = Number(
    get_first_present_value([safe_row.entity_profile_id, safe_row.id, safe_row.entity], 0)
  );
  const entity_type_id = Number(
    get_first_present_value(
      [safe_row.type_id, safe_row.entity_type_id, Reflect.get(child_raw, "entity_type_id")],
      0
    )
  );
  const user_id = Number(
    get_first_present_value([safe_row.user_id, get_child_profile_user_id(safe_row)], 0)
  );
  const navigation_query = {
    application_id: String(application_id),
    status: get_status_value(row),
    entity_profile_id: String(entity_profile_id),
    entity_type_id: String(entity_type_id),
    entity_name: get_first_present_value(
      [Reflect.get(safe_row, "Entity Name"), safe_row.entity_name],
      "Unknown Entity"
    ),
    entity_type_name: get_first_present_value(
      [get_entity_type_name(row, ""), Reflect.get(child_forms[0] || {}, "entity_type_name")],
      ""
    ),
    ...build_current_parent_context(vm),
  };

  if (user_id) {
    navigation_query.user_id = String(user_id);
  }

  return navigation_query;
}

export function sync_parent_session(vm) {
  const parent_query = vm.$route?.query || {};
  const parent_active_tab = String(parent_query.parent_active_tab || "");
  const is_dynamic_parent_tab = parent_active_tab.startsWith("ms-");
  const values = {
    application_id: parent_query.parent_application_id,
    entity_profile_id: parent_query.parent_entity_profile_id,
    user_id: parent_query.parent_user_id,
    entity_type_id: parent_query.parent_entity_type_id,
    entity_name: parent_query.parent_entity_name,
    entity_type_name: parent_query.parent_entity_type_name,
    application_status: parent_query.parent_status,
  };

  Object.entries(values).forEach(([key, value]) => {
    if (value) {
      sessionStorage.setItem(key, String(value));
    }
  });

  sessionStorage.removeItem('application_form_id');
  sessionStorage.removeItem('profile_role_form_id');

  if (parent_query.parent_active_tab) {
    sessionStorage.setItem(
      'active_tab',
      is_dynamic_parent_tab ? 'Overview' : String(parent_query.parent_active_tab)
    );
  } else {
    sessionStorage.setItem('active_tab', 'Overview');
  }

  if (parent_query.parent_master_tab) {
    sessionStorage.setItem('active_master_tab', String(parent_query.parent_master_tab));
  } else {
    sessionStorage.setItem('active_master_tab', 'profile');
  }
}

export function get_parent_entity_type_id(vm) {
  const route_entity_type_id = vm.$route?.query?.entity_type_id;
  const session_entity_type_id = sessionStorage.getItem("entity_type_id");
  const parent_entity_type_id = Number(
    get_first_present_value([route_entity_type_id, session_entity_type_id], 0)
  );

  return parent_entity_type_id;
}

export function build_child_tab_map(child_tabs) {
  const child_entity_tab_map = {};

  child_tabs.forEach((tab) => {
    Reflect.set(child_entity_tab_map, tab.id, {
      id: tab._child_entity_type_id,
      name: tab.label,
    });
  });

  return child_entity_tab_map;
}

export function get_visible_tabs_without_child_tabs(visible_tabs) {
  const filtered_tabs = (visible_tabs || []).filter(
    (tab) => !String(tab?.id || "").startsWith("child-")
  );

  return filtered_tabs;
}

export function normalize_sub_entity_item(item) {
  const is_child = Boolean(item?.is_child);
  const child_raw = get_child_raw(item);
  const child_forms = get_child_forms(item);
  const normalized_item = {
    is_child,
    type_id: Number(
      get_first_present_value(
        [item?.type_id, item?.entity_type_id, Reflect.get(child_raw, "entity_type_id")],
        0
      )
    ),
    application_id: Number(
      get_first_present_value(
        [
          Reflect.get(item || {}, "Application No"),
          item?.application_id,
          Reflect.get(child_forms[0] || {}, "application_id"),
        ],
        0
      )
    ),
    entity_profile_id: get_entity_profile_id(item, is_child),
    entity_type_name: get_entity_type_name(item),
  };

  return normalized_item;
}
